export type AnalyticsEvent =
  | "observatory_view"
  | "tool_opened"
  | "onboarding_started"
  | "email_captured"
  | "radar_filter_changed"
  | "radar_entity_opened"
  | "assessment_started"
  | "assessment_completed"
  | "profile_saved"
  | "career_selected"
  | "learning_resource_clicked";

export function track(event: AnalyticsEvent, payload: Record<string, string | number | boolean> = {}): void {
  const safe = { ...payload };
  delete safe.answers;
  delete safe.userLevel;
  const detail = { event, ...safe, ts: Date.now() };
  window.dispatchEvent(new CustomEvent("boostscience-observatory-analytics", { detail }));
  const dataLayer = (window as Window & { dataLayer?: unknown[] }).dataLayer;
  if (Array.isArray(dataLayer)) dataLayer.push(detail);
}
